export enum Modality {
  VIRTUAL = 'VIRTUAL',
  IN_PERSON = 'IN_PERSON'
}
